import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=60bed298&scoped=true&"
import script from "./Options.vue?vue&type=script&lang=js&"
export * from "./Options.vue?vue&type=script&lang=js&"
import style0 from "./Options.vue?vue&type=style&index=0&id=60bed298&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bed298",
  null
  
)

export default component.exports